import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const passwordMatchValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const password = control.get('password');
  const confirmPassword = control.get('confirmPassword');

  if (password?.value === confirmPassword?.value) {
    confirmPassword?.setErrors(null);
    return null;
  } else {
    confirmPassword?.setErrors({ notMatched: true });
    return { notMatched: true };
  }
};
